export async function getBytesFromBlobLike(blobLike) {
    if (!blobLike.arrayBuffer) {
        throw new Error("Unexpectedly missing implementation of Blob.arrayBuffer");
    }
    return new Uint8Array(await blobLike.arrayBuffer());
}
export function createBlobFromBuffer(buffer, mimeType) {
    return new Blob([buffer], { type: mimeType });
}
//# sourceMappingURL=fetch.js.map